import {
  dataPurposes,
  dataCollected,
  dataTransferCountries,
  legalBasis,
  technologyUsed,
} from '@usercentrics/template-app-translations';
import { IAiEnrichmentResult } from 'lib/Interfaces/IAiEnrichment';

function getTranslationKeys(translations: Record<string, Record<string, string>> | Record<string, string>): string[] {
  const source =
    'en' in translations
      ? (translations as Record<string, Record<string, string>>)['en']
      : (translations as Record<string, string>);
  return Object.keys(source);
}

// Computed once at module load — used both as API payload and for apply-time validation
export const TAG_KEYS: Record<string, string[]> = {
  dataPurposesList: getTranslationKeys(dataPurposes),
  dataCollectedList: getTranslationKeys(dataCollected),
  locationOfProcessing: getTranslationKeys(dataTransferCountries),
  thirdCountryTransfer: getTranslationKeys(dataTransferCountries),
  technologyUsed: getTranslationKeys(technologyUsed),
  legalBasisList: getTranslationKeys(legalBasis),
};

export async function analyzeServiceUrl(
  url: string,
  language: string,
  signal?: AbortSignal,
): Promise<IAiEnrichmentResult> {
  const apiUrl = process.env.REACT_APP_ENRICHMENT_API_URL;
  if (!apiUrl) {
    throw new Error('REACT_APP_ENRICHMENT_API_URL is not configured');
  }

  const res = await fetch(`${apiUrl}/analyze`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ url, language, tag_keys: TAG_KEYS }),
    signal,
  });

  if (!res.ok) throw new Error(`Server error: ${res.status}`);
  const json = (await res.json()) as unknown;
  if (typeof json !== 'object' || json === null) {
    throw new Error('Unexpected response shape from enrichment API');
  }
  return json as IAiEnrichmentResult;
}
